import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';

export const ErrorRow = styled(Row)`
  align-self: flex-end;
  width: 213px;
`;
